module.exports = {
  oneClick: {
    saveCardCheckboxLabel: 'Bu kartı gelecekteki alışverişler için kaydetmek istiyorum.',
    cardInfoLabel: '{brand} son {lastFour}',
    newCreditCardLabel: 'Başka bir kredi kartı kullan',
  },
  creditcardButtonMessage: 'Kredi Kartı ile öde',
  debitcardButtonMessage: 'Banka kartı ile öde',
  externalpayproviderButtonMessage: 'Fawry ile öde',
  banktransferButtonMessage: 'Banka Havalesi ile Öde',
  cardNumberLabel: 'Kart numarası',
  methodName: {
    creditcard: 'Kredi kartı',
    debitcard: 'Banka kartı',
    externalpayprovider: 'Fawry',
    paymob: 'Mobil Cüzdan',
  },
  info: {
    paymob: {
      payButton: 'Mobil Cüzdan ile Öde',
      phoneNumber: 'Onayladıktan sonra otomatik olarak cüzdanınıza yönlendirileceksiniz.',
      title: 'Mobil cüzdanınızla kolayca ödeyin!',
      description: 'Mısır Merkez Bankası tarafından yetkilendirilmiş herhangi bir mobil cüzdan kullanarak ödemenizi tamamlayabilirsiniz — doğrudan telefonunuzdan hızlı, güvenli ve pratik işlemler yapın.',
    },
  },
};
